var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMixChartLineAndBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 6.5,
    stroke: "var(--report-widget-icon-stroke-outer)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7998,
    y: 25,
    width: 3,
    height: 5,
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7002,
    y: 12,
    width: 3,
    height: 18,
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 17,
    width: 3,
    height: 13,
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3784 17.1065L31.75 16.8893V16.4589V14V12.6895L30.6201 13.3533L23.834 17.3402L20.0254 15.0943L19.6465 14.8709L19.2666 15.0925L10.6222 20.1339L10.25 20.3509V20.7818V23.2632V24.5702L11.3785 23.9107L19.6454 19.0787L23.4562 21.2953L23.8342 21.5152L24.2117 21.2946L31.3784 17.1065Z",
    fill: "#F37321",
    stroke: "var(--report-widget-icon-stroke-light)",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixChartLineAndBar);
export default __webpack_public_path__ + "static/media/mix-chart-line-and-bar.ed54c9f18b8c582dca4c3e43081f23c1.svg";
export { ForwardRef as ReactComponent };